/**
 * @type {Object}
 * @property {array}  data  Order data
 */
const initialState = {
    purchaseHistoryData: [],
    itemHistoryData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const purchaseHistoryReducer = (state = initialState, action) => {
    const newState = { ...state }
    var { data } = action;
    switch (action.type) {
        case 'FETCH_PURCHASE_HISTORY_DATA':
            var { data } = action;
            newState.purchaseHistoryData = data;
            break;

        case 'FETCH_ITEM_HISTORY_DATA':
            var { data } = action;
            newState.itemHistoryData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default purchaseHistoryReducer;
